module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration013.ea4f6f8e.webp";